export const SliderData = [
    {
      image: 'https://pbs.twimg.com/media/FWZuQqLakAcxmvV?format=jpg&name=4096x4096'
    },
    {
      image: 'https://pbs.twimg.com/media/FWZupazacAEfp5Y?format=jpg&name=4096x4096'
    },
    {
      image: 'https://pbs.twimg.com/media/FWZui7LaIAAy6ci?format=jpg&name=4096x4096'
    },
    {
      image: 'https://pbs.twimg.com/media/FWZuc2-aUAAu2QP?format=jpg&name=4096x4096'
    },
    {
      image: 'https://pbs.twimg.com/media/FWZuc3MaQAAxwz4?format=jpg&name=4096x4096'
    },
    {
      image: 'https://pbs.twimg.com/media/FWZuc3SagAAgNt4?format=jpg&name=4096x4096'
    },
    {
      image: 'https://pbs.twimg.com/media/FWZuvyKagAAOMqk?format=jpg&name=4096x4096'
    },
  ];